import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function SelectFilter({
  label,
  value,
  onChange,
  options,
  disabled = false,
  displayOption = (opt) => opt,
}) {
  return (
    <Grid item xs={12} sm={4}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          onChange={onChange}
          label={label}
          disabled={disabled}
        >
          {options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {displayOption(opt)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
}
